import { render, staticRenderFns } from "./auction-halls-groups.vue?vue&type=template&id=dc3710d8&"
import script from "./auction-halls-groups.vue?vue&type=script&lang=js&"
export * from "./auction-halls-groups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports